var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunder2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0479 12.8018C24.8859 12.5126 24.5802 12.3335 24.2485 12.3335H17.9116L18.7455 2.32649C18.7804 1.90757 18.5257 1.51868 18.1278 1.38307C17.7317 1.24654 17.2909 1.39922 17.0626 1.75237L6.97936 17.3355C6.79672 17.6175 6.78285 17.9768 6.94356 18.2718C7.10426 18.5667 7.41306 18.7501 7.74873 18.7501H14.0919L13.2514 29.6798C13.2187 30.1024 13.4801 30.4922 13.8833 30.6225C13.9764 30.6525 14.0713 30.6668 14.1653 30.6668C14.4777 30.6668 14.7776 30.5062 14.9477 30.2282L25.0309 13.7284C25.2037 13.4455 25.2104 13.0909 25.0479 12.8018ZM15.3716 26.0181L15.996 17.9039C16.0157 17.6492 15.928 17.3981 15.7547 17.2105C15.5811 17.0234 15.3371 16.9168 15.082 16.9168H9.43391L16.6145 5.81904L16.0018 13.1742C15.9808 13.4298 16.0672 13.6821 16.2408 13.871C16.4145 14.0595 16.6588 14.1668 16.9153 14.1668H22.614L15.3716 26.0181Z",
    fill: "#E92B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder2);
export default __webpack_public_path__ + "static/media/thunder-2.abc84e6d640d43dcaabb118173914415.svg";
export { ForwardRef as ReactComponent };